import type { GameManifest } from "../../contracts/game";

export const aDarkRoomManifest: GameManifest = {
  id: "a-dark-room",
  title: "A Dark Room",
  version: "1.4-carcade.1",
  status: "playable",
  coverAsset: "/covers/a-dark-room.svg",
  catalogOrder: 6,
  preferredAspectRatio: 16 / 9,
  supportsCpu: false,
  offline: "online-only",
  load: () => import("./index"),
};
